import PubSub from "underpub-js";

var ContentTextTypeTwo = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ContentTextTypeTwo',
	};

	$.extend(true, this.options, options);

};

ContentTextTypeTwo.prototype.init = function() {

	var self = this;

};

export default ContentTextTypeTwo;
